export enum RangeRegionParticipation {
    without = 0,
    regionalPreference = 1,
    localPreference = 2,
    regionalExclusivity = 3,
    localExclusivity = 4,
}
